const palette = {
  primary: {
    main: "#CA8C77",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#CA8C77",
    contrastText: "#ffffff",
  },
  text: {
    primary: "#000000",
    
  },
  success: {
    main: "#0E912C",
  },
  common: {
    black: "#000000",
    white: "#FFFFFF",
  },
};

export default palette;
